import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { Outlet } from "react-router-dom";
import { API_BASE_URL } from "../api";

const BackofficeAuthContext = createContext();

// Fully independent from AuthProvider/useAuth — the backoffice is its own auth realm
// (PlatformAdmin, checked via the "admin_jwt" cookie), not a role on a pharmacy account.
export function BackofficeAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = () => {
    return axios.get(`${API_BASE_URL}/api/backoffice-auth/me`, { withCredentials: true })
      .then(({ data }) => setAdmin(data))
      .catch(() => setAdmin(null))
      .finally(() => setLoading(false));
  };

  useEffect(() => { checkAuth(); }, []);

  const login = (username, password) => {
    return axios.post(`${API_BASE_URL}/api/backoffice-auth/login`, { username, password }, { withCredentials: true })
      .then(() => checkAuth());
  };

  const logout = () => {
    return axios.post(`${API_BASE_URL}/api/backoffice-auth/logout`, {}, { withCredentials: true })
      .then(() => setAdmin(null));
  };

  return (
    <BackofficeAuthContext.Provider value={{ admin, loading, login, logout }}>
      {children ?? <Outlet />}
    </BackofficeAuthContext.Provider>
  );
}

export const useBackofficeAuth = () => useContext(BackofficeAuthContext);
